import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";
import type {
    GroupedTechnologies,
    TechnologiesFilterDto,
} from "app/pages/sales-intelligence/modules/technology/types/technologies";

export default class FindTechnologyFilter extends FilterPanelBaseFilter<TechnologiesFilterDto[], GroupedTechnologies> {
    constructor(deps: IFilterPanelBaseFilterDeps<TechnologiesFilterDto[], GroupedTechnologies>) {
        super(deps);
    }

    calculateValueDelta(
        previousValue: TechnologiesFilterDto[] | undefined,
        newValue: TechnologiesFilterDto[] | undefined,
    ): FilterValueDelta<TechnologiesFilterDto> {
        return calculateArrayDelta(previousValue, newValue);
    }
}
